import clsx from "clsx";
import { t } from "../../i18n/strings";
import type { Turn } from "../../engine/types";
import type { Locale } from "../../templates/types";

export function MessageBubble({ turn, locale = "en" }: { turn: Turn; locale?: Locale }) {
  const isAgent = turn.role === "agent";

  return (
    <div className={clsx("flex flex-col gap-1", isAgent ? "items-start" : "items-end")} aria-live={isAgent ? "polite" : undefined}>
      {isAgent && (
        <span className="px-1 text-xs font-medium uppercase tracking-wide text-ink-soft">
          {t(locale, "chat.message.aiAgent")}
        </span>
      )}
      <div
        className={clsx(
          "max-w-[85%] rounded-lg px-4 py-2.5 text-sm leading-relaxed",
          isAgent ? "bg-paper-dim text-ink" : "bg-sage-strong text-paper",
        )}
      >
        {turn.text}
      </div>
      {turn.inputMode === "voice" && !isAgent && (
        <span className="px-1 text-xs text-ink-soft">{t(locale, "chat.message.viaVoice")}</span>
      )}
    </div>
  );
}
